import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import AddOrderPage from './AddOrderPage';

import StoreTable from './StoreTable';
import KanbanView from './kanbanview';

function App() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const storedUser = localStorage.getItem('username');
    if (storedUser) {
      setUsername(storedUser);
      setIsLoggedIn(true);
    }
  }, []);

  const handleLogin = (e) => {
    e.preventDefault();
    if (username && password) {
      localStorage.setItem('username', username);
      setIsLoggedIn(true);
    }
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
    setUsername('');
    setPassword('');
    localStorage.removeItem('username');
  };

  if (!isLoggedIn) {
    return (
      <div className="d-flex align-items-center justify-content-center vh-100 bg-light">
        <div className="card shadow p-4" style={{ width: '100%', maxWidth: '400px' }}>
          <h3 className="text-center mb-4">Store Data Login</h3>
          <form onSubmit={handleLogin}>
            <div className="mb-3">
              <label htmlFor="username" className="form-label">Username</label>
              <input
                type="text"
                className="form-control"
                id="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
            </div>
            <div className="mb-3">
              <label htmlFor="password" className="form-label">Password</label>
              <input
                type="password"
                className="form-control"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            <button type="submit" className="btn btn-primary w-100">Login</button>
          </form>
        </div>
      </div>
    );
  }

  return (
    <Router>
      <div className="container py-4">
        <div className="d-flex justify-content-between align-items-center mb-4 border-bottom pb-2">
          <h2 className="mb-0">Welcome, Loreal Luxury India!</h2>
          <button className="btn btn-outline-danger" onClick={handleLogout}>Logout</button>
        </div>
        <Routes>
          <Route path="/" element={<StoreTable />} />
          <Route path="/kanban" element={<KanbanView />} />
          <Route path="*" element={<Navigate to="/" />} />
          <Route path="/add-order" element={<AddOrderPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
